import { useState } from 'react'
import type { FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'

function VerifyEmailPage() {
  const navigate = useNavigate()

  const storedEmail =
    localStorage.getItem('aad_verification_email') || ''

  const [email] = useState(storedEmail)
  const [code, setCode] = useState('')
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [resending, setResending] = useState(false)

  async function handleVerify(
    event: FormEvent<HTMLFormElement>,
  ) {
    event.preventDefault()

    setError('')
    setMessage('')
    setLoading(true)

    try {
      const response = await fetch(
        '/api/auth/verify-email',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email,
            code,
          }),
        },
      )

      const data = await response.json()

      if (!response.ok) {
        setError(
          typeof data.detail === 'string'
            ? data.detail
            : 'Verification failed.',
        )
        return
      }

      setMessage('Email verified successfully.')

      localStorage.removeItem(
        'aad_verification_email',
      )

      setTimeout(() => {
        navigate('/login')
      }, 1000)
    } catch {
      setError(
        'Unable to connect to the server.',
      )
    } finally {
      setLoading(false)
    }
  }

  async function handleResend() {
    setError('')
    setMessage('')
    setResending(true)

    try {
      const response = await fetch(
        '/api/auth/resend-verification',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email,
          }),
        },
      )

      const data = await response.json()

      if (!response.ok) {
        setError(
          typeof data.detail === 'string'
            ? data.detail
            : 'Unable to resend code.',
        )
        return
      }

      setMessage(
        data.message ||
          'A new verification code has been sent.',
      )
    } catch {
      setError(
        'Unable to connect to the server.',
      )
    } finally {
      setResending(false)
    }
  }

  return (
    <main>
      <section>
        <h1>Verify your email</h1>

        <p>
          We sent a 6-digit verification code to:
        </p>

        <strong>{email}</strong>

        <form onSubmit={handleVerify}>
          <div>
            <label htmlFor="code">
              Verification code
            </label>

            <input
              id="code"
              name="code"
              type="text"
              inputMode="numeric"
              value={code}
              onChange={(event) =>
                setCode(
                  event.target.value
                    .replace(/\D/g, '')
                    .slice(0, 6),
                )
              }
              maxLength={6}
              required
            />
          </div>

          {error && (
            <p role="alert">
              {error}
            </p>
          )}

          {message && (
            <p>
              {message}
            </p>
          )}

          <button
            type="submit"
            disabled={
              loading ||
              code.length !== 6 ||
              !email
            }
          >
            {loading
              ? 'Verifying...'
              : 'Verify email'}
          </button>
        </form>

        <button
          type="button"
          onClick={handleResend}
          disabled={resending || !email}
        >
          {resending
            ? 'Sending...'
            : 'Resend code'}
        </button>
      </section>
    </main>
  )
}

export default VerifyEmailPage